import { createContext, ReactNode, useContext } from "react";

type CandidateTimezoneContextValue = {
  timezone: string | null;
};

const CandidateTimezoneContext = createContext<CandidateTimezoneContextValue>({
  timezone: null,
});

export function useCandidateTimezoneContext() {
  const context = useContext(CandidateTimezoneContext);

  if (!context) {
    return {
      timezone: null,
    };
  }

  return context;
}

export function CandidateTimezoneProvider({
  children,
  timezone,
}: {
  children: ReactNode;
  timezone: string | null;
}) {
  return (
    <CandidateTimezoneContext.Provider value={{ timezone }}>
      {children}
    </CandidateTimezoneContext.Provider>
  );
}
